export default "__VITE_ASSET__bBcvvAXz__"